import { render } from "./InsufficientPrivileges.vue?vue&type=template&id=72163429&scoped=true"
import script from "./InsufficientPrivileges.vue?vue&type=script&lang=js"
export * from "./InsufficientPrivileges.vue?vue&type=script&lang=js"

import "./InsufficientPrivileges.vue?vue&type=style&index=0&id=72163429&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72163429"]])

export default __exports__